import React, { Component }  from 'react';
import { PubSubConstants }   from './environment';
import { isInRoleFromToken } from '../../../utils/authService';

class PubSubBreadcrumb extends Component {

  render() {
    if (isInRoleFromToken(PubSubConstants.AdminRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
            <li className="c-breadcrumbs__item">
              <a href={PubSubConstants.UserHashPrefix + '/execute'} className="anchor c-breadcrumbs__anchor" >
                Execute
              </a>
            </li>
            <li className="c-breadcrumbs__item">
              <a href={PubSubConstants.AdminHashPrefix + '/list'} className="anchor c-breadcrumbs__anchor" >
                List
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else if (PubSubConstants.UserRole === "*" || isInRoleFromToken(PubSubConstants.UserRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
            <li className="c-breadcrumbs__item">
              <a href={PubSubConstants.UserHashPrefix + '/execute'} className="anchor c-breadcrumbs__anchor" >
                Execute
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else {
      // Not logged in or wrong role
    }
  }
}

export default PubSubBreadcrumb;